module.exports = __webpack_public_path__ + "media/images/favicon-ee3d8729a0d24c403a9d7c0879ea4c94.ico";